import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  ContractorResponseDto
} from 'app/services/authentication/connection/interfaces/apiInterfaces';

export class GetContractorByTributeNumberCommand extends IRequestCommand<
  IGetContractorByTributeNumberResponse,
  ErrorDetails,
  IGetContractorByTributeNumberCommandParameters
  > {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'contractors/tribute/{tributeNumber}';
  public override setParameters(parameters: IGetContractorByTributeNumberCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{tributeNumber}',
      parameters.tributeNumber
    );
  }
}

export interface IGetContractorByTributeNumberCommandParameters
  extends ICommandParameters {
  tributeNumber: string;
}

export interface IGetContractorByTributeNumberResponse
  extends ContractorResponseDto,
    ICommandResponse {}
